import { atom } from "jotai";

export const branchFiltersAtom = atom<any>({
  dataType: "Sum",
  dateType: "Last 7 Days",
});
